import Modal from "soapbox/components/ui/modal.tsx";
import Spinner from "soapbox/components/ui/spinner.tsx";

const ModalLoading = () => (
  <Modal>
    <Spinner />
  </Modal>
);

export default ModalLoading;
